import PropTypes from "prop-types"

export const cartType = PropTypes.shape({
  color: PropTypes.string,
  created_at: PropTypes.string,
  id: PropTypes.number,
  image_url: PropTypes.string,
  name: PropTypes.string,
  updated_at: PropTypes.string,
})
